export default __webpack_public_path__ + "static/media/e-vectorial-w.e8a3e10b.svg";